"use strict";

var _AsyncBoundary;
import { c as _c } from "react/compiler-runtime";
import { SectionLoading } from '@autoguru/components';
import { StandardModal } from '@autoguru/overdrive';
import { StaticMFEShadowedComponent } from '@autoguru/static-mfe/static-mfe-shadowed-component';
import { AsyncBoundary } from '@autoguru/suspense';
import * as styles from './SupportHeaderModal.css';
import { jsx as _jsx } from "react/jsx-runtime";
export const SupportHeaderModal = t0 => {
  const $ = _c(8);
  const {
    showModal,
    changeState
  } = t0;
  let t1;
  if ($[0] !== changeState) {
    t1 = () => changeState();
    $[0] = changeState;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== showModal) {
    t2 = showModal && (_AsyncBoundary || (_AsyncBoundary = /*#__PURE__*/_jsx(AsyncBoundary, {
      fallback: SectionLoading,
      children: /*#__PURE__*/_jsx(StaticMFEShadowedComponent, {
        width: "full",
        mfeAppName: "gb-support-contact"
      })
    })));
    $[2] = showModal;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== showModal || $[5] !== t1 || $[6] !== t2) {
    t3 = /*#__PURE__*/_jsx(StandardModal, {
      onRequestClose: t1,
      isOpen: showModal,
      className: styles.container,
      title: "",
      children: t2
    });
    $[4] = showModal;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};